import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Title } from "../../../../../../themes/Default/components/Title";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { List } from "../../../../../../themes/Default/components/List";
import { Body as ListBody } from "../../../../../../themes/Default/components/List/components/Body";
import { Header as ListHeader } from "../../../../../../themes/Default/components/List/components/Header";
import { TableHead } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableRow } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableBody } from "../../../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableDataCell } from "../../../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Checkbox } from "../../../../../../themes/Default/components/Form/components/Checkbox";
import { Toaster } from "../../../../../../themes/Default/components/Toaster";
import { groupProgressTestsManagement } from "../../../../../../hooks/api/GroupProgressTestsManagement/GroupProgressTestsManagement";

const ProgressTests = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const [totalRecords, setTotalRecords] = useState(0);
    const [disableDelete, setDisableDelete] = useState(true);
    const [selectedProgressTest, setSelectedProgressTest] = useState([]);
    const [progressTests, setProgressTests] = useState();
    const { useGroupProgressTestsListMutation, useDeleteGroupProgressTestMutation } = groupProgressTestsManagement;
    const [groupProgressTestsList] = useGroupProgressTestsListMutation();
    const [deleteGroupProgressTest] = useDeleteGroupProgressTestMutation();

    const tabs = [
        { title: t("plans.title"), onClick: () => gotoPlansTab() },
        { title: t("groupTypes.title"), onClick: () => gotoTypeTab() },
        { title: t("groups.progress"), onClick: () => gotoProgressTab() },
        { title: t("groups.progressTest"), isActive: true },
    ];

    const gotoPlansTab = () => {
        navigate("/settings/groups/plans");
    };

    const gotoTypeTab = () => {
        navigate("/settings/groups/types");
    };

    const gotoProgressTab = () => {
        navigate("/settings/groups/progress");
    };

    const gotoNew = () => {
        navigate("/settings/groups/progress-tests/add");
    };

    const onSelectionChange = (id) => {
        setSelectedProgressTest((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedProgressTest?.length; i++) {
                            const progressTestId = selectedProgressTest[i];
                            deleteGroupProgressTest(progressTestId).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    groupProgressTestsList().then((result) => {
                                        const progressTests = result?.data?.records;
                                        setProgressTests(progressTests);
                                        setTotalRecords(result?.data?.totalRecords);
                                        setDisableDelete(true);
                                        onSelectionChange(progressTestId);
                                    });
                                    toast.info(result?.data?.info?.responseMessage);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    useEffect(() => {
        if (selectedProgressTest.length > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
    }, [selectedProgressTest]);

    useEffect(() => {
        groupProgressTestsList().then((result) => {
            setProgressTests(result?.data?.records);
            setTotalRecords(result?.data?.totalRecords);
        });
    }, [ groupProgressTestsList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings" />
                <Button title={t("groups.addTest")} icon="fa-regular fa-plus" onClick={gotoNew}></Button>
                <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={disableDelete} onClick={onDelete}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{`${t("groups.progressTest")} (${totalRecords})`}</Title>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("groups.title")} />
                    <Link title={t("groups.progressTest")} />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                        <List>
                            <ListHeader></ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("groupTypes.name")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {progressTests?.length > 0 &&
                                        progressTests?.map((progressTest, index) => {
                                            return (
                                                <TableRow key={progressTest.id}>
                                                    <TableDataCell>
                                                        <Checkbox name="isBlockClass" value={progressTest.id} onChange={() => onSelectionChange(progressTest.id)} />
                                                    </TableDataCell>
                                                    <TableDataCell>{progressTest.name}</TableDataCell>
                                                    <TableDataCell></TableDataCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </ListBody>
                        </List>
            </Main>
        </DefaultLayout>
    );
};

export default ProgressTests;
